import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ro');

  useEffect(() => {
    const storedLang = localStorage.getItem('rasLanguage');
    if (storedLang && (storedLang === 'ro' || storedLang === 'en')) {
      setLanguage(storedLang);
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'ro' ? 'en' : 'ro';
    localStorage.setItem('rasLanguage', newLang);
    setLanguage(newLang);
  };

  const setLang = (lang) => {
    if (lang === 'ro' || lang === 'en') {
      localStorage.setItem('rasLanguage', lang);
      setLanguage(lang);
    }
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
